export const REQUESTED = 1;
export const APPROVED = 2;
export const REJECTED = 3;
export const NO_STATUS = 100;
export const NOT_READY_TO_RECEIVE = 200;
